import React, { memo, forwardRef } from "react";
const SvgMatrixelement = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={8} height={14} x={5} y={9} fill="#DBDBDB" rx={2} />
      <rect width={5} height={9} x={27} y={19} fill="#DBDBDB" rx={1} />
      <rect width={5} height={9} x={20} y={19} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        d="M3.29 29H.923C.308 29 0 28.678 0 28.034V3.966C0 3.322.308 3 .923 3H3.29c.473 0 .71.223.71.669 0 .446-.237.669-.71.669H1.562v23.324H3.29c.473 0 .71.223.71.67 0 .445-.237.668-.71.668zM14.71 29h2.367c.615 0 .923-.322.923-.966V3.966c0-.644-.308-.966-.923-.966H14.71c-.473 0-.71.223-.71.669 0 .446.237.669.71.669h1.728v23.324H14.71c-.473 0-.71.223-.71.67 0 .445.237.668.71.668z"
      />
    </svg>
  );
});
SvgMatrixelement.displayName = "SvgMatrixelement";
const MemoForwardRef = memo(SvgMatrixelement);
export default MemoForwardRef;
